import { createSelector } from 'reselect';
import { get } from 'lodash';

const rootSelector = createSelector(
  (state) => state.get('appReducers'),
  (substate) => substate
);

const authSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'auth')
);

const membershipRoleSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'auth.membershipRole')
);

const adminMembershipIdSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'auth.adminMembershipId')
);

const isAuthenticatedSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'auth.authenticated')
);

const mfaSetupRequiredSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'auth.mfaSetupRequired')
);

const sessionSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session')
);

const userSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.user.model')
);

const userHydratedSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.user.hydrated', false)
);

const userChannelSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.user.channel')
);

const companySelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.company.model')
);

const socketSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.socket')
);

const companyChannelSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.company.channel')
);

const releaseSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.release')
);

const countersSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'session.counters')
);

const uiSelector = createSelector(rootSelector, (substate) =>
  get(substate, 'ui').toJS()
);

export {
  authSelector,
  sessionSelector,
  uiSelector,
  membershipRoleSelector,
  userSelector,
  userHydratedSelector,
  userChannelSelector,
  companySelector,
  socketSelector,
  companyChannelSelector,
  adminMembershipIdSelector,
  releaseSelector,
  isAuthenticatedSelector,
  mfaSetupRequiredSelector,
  countersSelector,
};
